import styled from "styled-components";
import { Input } from "antd";
import FormItem from "antd/lib/form/FormItem";
import {
  CommonGradientContainer,
  StyledSelect as CommonStyledSelect,
} from "pages/ProfileUser/profileUserInner.style";
import PrimaryButton from "components/base/primaryButton";

export const CustomSkillWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CustomSkillBtn = styled(PrimaryButton)``;

export const BuilderRight = styled.div``;

export const BuilderLeft = styled.div``;

export const BuilderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const BuilderSkillContainer = styled(CommonGradientContainer)`
  padding: 26px;
  margin-bottom: 48px;
`;

export const Heading = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  margin-top: 6px;
`;

export const Title = styled.div`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 125%;
  display: flex;
  align-items: center;
  letter-spacing: -0.04em;
  color: #080f6c;
  margin-left: 1rem;
`;
export const Description = styled.div<{ color?: string }>`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  display: flex;
  align-items: center;
  color: ${(p) => p.color || "rgba(41, 46, 115, 0.42)"};
  margin-top: 0.35rem;
`;

export const BigLabel = styled.div`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 120%;
  letter-spacing: -0.02em;
  color: #080f6c;
  margin-bottom: 0.3rem;
`;

export const StyledInput = styled(Input)`
  width: 100%;
  border: 0.0625rem solid rgba(41, 46, 115, 0.12);
  border-radius: 0.25rem;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 100%;
  display: flex;
  align-items: center;
  color: #080f6c;
  height: 2.25rem;
  padding: 0.625rem;
  &::placeholder {
    font-family: "DM Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: rgba(41, 46, 115, 0.42);
  }
`;
export const StyledTextArea = styled(Input.TextArea)`
  width: 100%;
  border: 0.0625rem solid rgba(41, 46, 115, 0.12);
  border-radius: 0.25rem;
  height: 5.875rem !important;
  padding: 0.625rem;

  &::placeholder {
    font-family: "DM Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: rgba(41, 46, 115, 0.42);
  }
`;

export const StyledFormItem = styled(FormItem)`
  label {
    font-family: "DM Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 100%;
    letter-spacing: -0.01em;
    color: #080f6c;
  }
  .ant-form-item-label {
    padding-bottom: 0.35rem;
  }
  margin-bottom: 18px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(156, 138, 193, 0.16);
  margin-bottom: 15px;
`;

export const BottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-right: 20px;
`;

export const UploadButton = styled.div`
  width: 84px;
  height: 84px;
  background: rgba(156, 138, 193, 0.13);
  border-radius: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 30px;
  }
  margin: 20px auto;
`;

export const KindSelect = styled.div<{ active?: boolean }>`
  height: 48px;
  border: 1px solid rgba(41, 46, 115, 0.12);
  border-radius: 4px;
  color: ${(p) => (p.active ? "white" : "rgba(41, 46, 115, 0.82)")};
  background: ${(p) => (p.active ? "#7E00FD" : "white")};
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
`;

export const BuilderKindGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  grid-gap: 10px;
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

export const LevelSelect = styled.div<{ active?: boolean }>`
  height: 36px;
  max-width: 108px;
  padding: 12px;
  border: 1px solid rgba(41, 46, 115, 0.12);
  border-radius: 4px;
  color: ${(p) => (p.active ? "white" : "rgba(41, 46, 115, 0.82)")};
  background: ${(p) => (p.active ? "#7E00FD" : "white")};
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 10px;
`;

export const LevelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div {
    display: flex;
  }
  margin-top: 0.75rem;
  max-width: 100%;
  overflow: hidden;
`;

export const KindText = styled.span`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  margin-right: 10px;
  color: #7e00fd;
`;

export const StyledSelect = styled(CommonStyledSelect)`
  width: 100%;
`;
